import brandConfig from '../../brand/brand-config.json';
import { PRACTICE_REGISTRATION_ROLE_PRACTICE } from '../../constants/Roles';

const defaultEnrollmentData = {
  initiatorRole: PRACTICE_REGISTRATION_ROLE_PRACTICE,
  brandId: brandConfig.brandId
};

export default defaultEnrollmentData;
